import { CircularProgress, Grid2 as Grid } from '@mui/material';
import { useAuth } from 'hooks/useAuth';
import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { RouteList } from 'types';
import { useAuthGAEvents } from 'hooks/useAuthGAEvents';

type AuthGuardProps = React.PropsWithChildren;

/**
 * AuthGuard component handles authentication logic and redirects.
 * This separates auth concerns from the RootComponent layout.
 */
export const AuthGuard = ({ children }: AuthGuardProps) => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useAuthGAEvents();

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      navigate(RouteList.Login, { state: { redirectTo: window.location.href } });
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <Grid container height="100vh">
        <CircularProgress sx={{ m: 'auto auto' }} />
      </Grid>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return children ?? <Outlet />;
};
